import React from "react";
import { useDispatch } from "react-redux";
import useValidate from "../../store/hooks/useValidator";
import { closeModal } from "../../store/actions/modalAction";
import { useEffect, useMemo, useState } from "react";
import { callApiAction } from "../../store/actions/commonAction";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import { createVersion } from "../../apis/version.api";
import VersionCreateUi from "./VersionCreateUi";

const VersionCreateController = ({
  callBack = () => {},
  id,
  isModal,
  handleAreaModalClose,
}) => {
  const validate = useValidate();
  const dispatch = useDispatch();
  const title = "Version";
  const stripHtml = (html) => html.replace(/<[^>]*>/g, "").trim();

  const [loading, setLoading] = useState(false);

  const [fields, setFields] = useState({
    err: "",
    id,
    name: "",
    main_version: "",
    sub_version: "",
    app_type: "",
    description: "",
  });

  const validationSchemaForCreate = useMemo(
    () => [
      {
        required: true,
        value: fields.name,
        field: "Version name",
      },
      {
        required: true,
        value: fields.main_version,
        field: "Main Version",
      },
      {
        required: true,
        value: fields.sub_version,
        field: "Sub Version",
      },
      // {
      //   required: true,
      //   value: fields.app_type,
      //   field: "App Type",
      // },
      {
        required: true,
        value: stripHtml(fields.description),
        field: "Description",
      },
    ],
    [fields]
  );

  const createFunction = async () => {
    const validationResponse = validate(validationSchemaForCreate);

    if (validationResponse === true) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await createVersion(fields),
          async (response) => {
            await callBack(response);
            setLoading(false);
            dispatch(closeModal("version"));
          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
          }
        )
      );
    } else {
      setFields({ ...fields, err: validationResponse });
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    createFunction();
  };

  return (
    <VersionCreateUi
      title={title}
      loading={loading}
      fields={fields}
      onSubmit={onSubmit}
      setFields={setFields}
      isModal={isModal}
      handleAreaModalClose={handleAreaModalClose}
    />
  );
};

export default VersionCreateController;
